export const setJobData = (data) => {
    return {
      type: 'SET_JOB_DATA',
      payload: data
    };
  };